export default {
  ACCOUNT_ID: 'selectAccountId',
  ACCOUNT_NAME: 'selectAccountName',
  AGORA_APP_ID: 'selectAgoraAppId',
  AGORA_AUTH_TOKENS: 'selectAgoraAuthTokens',
  API: 'selectApi',
  APP: 'selectApp',
  AUTH_TOKEN: 'selectAuthToken',
  BROADCAST_DESCRIPTION: 'selectBroadcastDescription',
  BROADCAST_GUESTS_ARRAY: 'selectBroadcastGuestsArray',
  BROADCAST_GUESTS_MAP_GUEST_ID: 'selectBroadcastGuestsMapGuestId',
  BROADCAST_GUESTS_MAP_USER_ID: 'selectBroadcastGuestsMapUserId',
  BROADCAST_HASH: 'selectBroadcastHash',
  BROADCAST_HOST_USER: 'selectBroadcastHostUser',
  BROADCAST_ID: 'selectBroadcastId',
  BROADCAST_NAME: 'selectBroadcastName',
  BROKER_TOKEN: 'selectBrokerToken',
  BROKER_URL: 'selectBrokerUrl',
  CHANNEL_NAME: 'selectChannelName',
  CHANNEL_TOKEN: 'selectChannelToken',
  CHAT_TOKEN: 'selectChatToken',
  ENVIRONMENT_CONFIG: 'selectEnvironmentConfig',
  FEATURE_TYPES: 'selectFeatureTypes',
  FEATURE: 'selectFeature',
  HOST_URL: 'selectHostUrl',
  HAS_ENTERED_BROADCAST: 'selectHasEnteredBroadcast',
  INTERCOM_APP_ID: 'selectIntercomAppId',
  IS_PRODUCTION: 'selectIsProduction',
  LOG_ROCKET_ID: 'selectLogRocketId',
  LOG_ROCKET_NAME: 'selectLogRocketName',
  MIXPANEL_TOKEN: 'selectMixpanelToken',
  PLATFORM: 'selectPlatform',
  QUERIES: 'selectQueries',
  RTMP_DATA: 'selectRtmpData',
  SIMULCAST_SUBSTREAM: 'selectSimulcastSubstream',
  SPEAKER_SINK_ID: 'selectSpeakerSinkId',
  SPLIT_API_KEY: 'selectSplitApiKey',
  SPLIT_HAS_FEATURE_LOADED: 'selectHasFeatureLoaded',
  SPLIT_INIT: 'selectSplitInit',
  SPLIT_SLICE_NAME: 'selectSplitSliceName',
  SPLIT_STATUS: 'selectSplitStatus',
  STREAM_CONFIGS_ARRAY: 'selectStreamConfigsArray',
  STREAM_CONFIGS_MAP_STREAM_TYPE: 'selectStreamConfigsMapStreamType',
  STREAM_CONFIGS_MAP_SFU_FEED_ID: 'selectStreamConfigsMapSfuFeedId',
  STREAMS: 'selectStreams',
  TEST_ID: 'selectTestId',
  TOAST: 'selectToast',
  USER: 'selectUser',
  USER_ACCOUNT_ROLE: 'selectUserAccountRole',
  USER_BROADCAST_ROLE: 'selectUserBroadcastRole',
  USER_EMAIL: 'selectUserEmail',
  USER_ID: 'selectUserId',
  USER_LOCATION: 'selectUserLocation',
  USER_NAME: 'selectUserName',
  VERSION: 'selectVersion',
  PREFERENCES: 'selectPreferences',
};
